import { ConfigType } from 'dayjs'

import dayjs from 'utils/dayjs'

export const formatTimeForInput = (timeString: ConfigType): string => {
  // NOTE: dayjs doesn't support local time with lowercase am/pm,
  // so can't use the 'LT' token
  return dayjs(timeString).format('hh:mm a')
}

export const formatDateForInput = (dateString: ConfigType): string => {
  return dayjs(dateString).format('l')
}

const formatTimeInputTo24Hours = (
  time: string
): { hours: number; minutes: number } | null => {
  const tempDateTime24Hour = dayjs(`2000-01-01 ${time}`).toDate()
  if (!dayjs(tempDateTime24Hour).isValid()) {
    return null
  }
  const [hours, minutes] = dayjs(tempDateTime24Hour)
    .format('HH:mm')
    .split(':')
    .map(Number)
  return { hours, minutes }
}

export const replaceDateTimeWithTime = (
  date: ConfigType,
  time: string
): Date | null => {
  const formattedTime = formatTimeInputTo24Hours(time)
  if (!formattedTime) {
    return null
  }

  const { hours, minutes } = formattedTime
  const newDate = dayjs(date).hour(hours).minute(minutes).toDate()
  return newDate
}

export const getDateFromInputValue = (value: string): Date | null => {
  const date = dayjs(value, 'l').toDate()
  return !dayjs(date).isValid() ? null : date
}
